import { render } from "./SelectionMenuStep7.vue?vue&type=template&id=c8351f56&scoped=true"
import script from "./SelectionMenuStep7.vue?vue&type=script&lang=ts"
export * from "./SelectionMenuStep7.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-c8351f56"

export default script